import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./pages/Hero";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Education from "./pages/Education";
import Experience from "./pages/Experience";
import Extracurriculars from "./pages/Extracurriculars";
import Contact from "./pages/Contact";
import Game from "./pages/Game";
import "./styles.css";
import BackgroundAnimation from "./components/BackgroundAnimation";
import SpaceLoading from "./components/LoadingAnimation";

function App() {
  const location = useLocation(); // Get the current location

  return (
    <>
      {location.pathname !== "/game" ? (
        <SpaceLoading key={location.pathname}>
          <div className="App">
            {!location.pathname.startsWith("/game") && <Navbar />}
            {!location.pathname.startsWith("/game") && <BackgroundAnimation/>}
            <Routes>
              <Route path="/" element={<Hero />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/education" element={<Education />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/extracurriculars" element={<Extracurriculars />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/game" element={<Game />} />
            </Routes>
          </div>
        </SpaceLoading>
      ) : (
        <div className="App">
          <Routes>
            <Route path="/game" element={<Game />} />
          </Routes>
        </div>
      )}
    </>
  );
}

function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default Root;